// src/components/AdSenseUnit.js
import React, { useEffect } from 'react';

/**
 * Component to display a Google AdSense ad unit.
 * Requires the main AdSense script to be loaded in index.html.
 *
 * Props:
 *  - client (string): Your AdSense Publisher ID (e.g., 'ca-pub-1234567890'). Required.
 *  - slot (string): Your Ad Unit Slot ID (e.g., '9876543210'). Required.
 *  - style (object): Styles for the ad container (e.g., { display: 'block' }). AdSense often requires display: block.
 *  - format (string): Ad format (e.g., 'auto', 'rectangle', 'vertical'). Defaults to 'auto'.
 *  - responsive (string): Whether the ad unit is responsive ('true' or 'false'). Defaults to 'true'.
 */
const AdSenseUnit = ({
    style = { display: 'block', textAlign: 'center' }, // Default style, center aligns if block
    client = 'ca-pub-4436314978974811', 
    slot = '9600025944',
    format = 'auto',
    responsive = 'true'
}) => {

    useEffect(() => {
        // Check if running in a browser environment
        if (typeof window !== 'undefined') {
            try {
                // Push an ad request to AdSense after the component mounts.
                // The `adsbygoogle` object should be available globally if the main script in index.html loaded.
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                // console.log(`AdSense push for slot ${slot}`); // Optional: for debugging
            } catch (e) {
                // Log error if push fails (e.g., AdBlocker, script failed to load)
                console.error(`AdSense error for slot ${slot}: ${e}`);
            }
        }
    }, []); // Empty dependency array ensures this effect runs only once after the initial render

    // Basic check for placeholder props in development mode
    if (process.env.NODE_ENV !== 'production') {
        //if (client === 'ca-pub-YOUR_CLIENT_ID' || slot === 'YOUR_SLOT_ID') {
            return (
                <div style={{
                    background: '#f0f0f0',
                    border: '1px dashed #ccc',
                    padding: '20px',
                    margin: '10px 0',
                    textAlign: 'center',
                    minHeight: '90px', // Example height
                    color: '#666'
                 }}>
                    Ad Placeholder (Slot: {slot})<br/>
                    <small>Update client/slot IDs in AdSenseUnit.js</small>
                </div>
            );
        //}
    }

    // Render the AdSense <ins> tag
    // This tag is what AdSense script looks for to inject the ad
    return (
        <ins className="adsbygoogle"
             style={style}
             data-ad-client={client}
             data-ad-slot={slot}
             data-ad-format={format}
             data-full-width-responsive={responsive}>
        </ins>
    );
};

export default AdSenseUnit;
